<template>
  <div class="privacy">
    <v-container>
      <p>
        当サイトでは、Googleによるアクセス解析ツール「Googleアナリティクス」を使用しています。
      </p>
      <p>
        このGoogleアナリティクスはデータの収集のためにCookieを使用しています。
      </p>
      <p>
        このデータは匿名で収集されており、個人を特定するものではありません。
      </p>
      <p>
        この機能はCookieを無効にすることで収集を拒否することが出来ますので、お使いのブラウザの設定をご確認ください。
      </p>
      <p>
        この規約に関しての詳細は
        <a href="https://marketingplatform.google.com/about/analytics/terms/jp/" target="_blank"
          >Googleアナリティクスサービス利用規約のページ</a
        >
        や
        <a href="https://policies.google.com/technologies/ads?hl=ja" target="_blank"
          >Googleポリシーと規約ページ</a
        >
        をご覧ください。
      </p>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      AppName: process.env.VUE_APP_NAME,
      AppUrl: process.env.VUE_APP_URL,
    };
  },
};
</script>